import React from 'react'
import utils from './utils'

function getLevelLayout(width, height, settings, quantities, answer) {
    return getLayout(width, height, settings, quantities, answer)
}

function getLayout(width, height, settings, quantities, answer) {
    const {
        gameContainerWidth,
        gameContainerHeight,
        sideMargin,
        rectWidth,
        rectHeight,
        marginBottom,
        lineWeight,
        arrowSize,
        fontSize,
        gridCount
    } = getLayoutSettings(width, height)
    const double = settings.type === 'double' ? true : false
    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}
        >
            {!double && getFrame(quantities.value_1, quantities.value_2, lineWeight, lineWeight, gameContainerWidth, gameContainerHeight, lineWeight, settings)}
            {double && getDoubleFrame(quantities.value_1, quantities.value_2, lineWeight, lineWeight, gameContainerWidth, gameContainerHeight, lineWeight, settings)}
        </svg>
    )
}

function getDoubleFrame(value_1, value_2, x, y, width, height, lineWeight, settings) {
    const parallel = settings.show_parallel || false
    const vertical = settings.orientation === 'vertical' ? true : false
    const gridCount = 5
    let signSize = height / 5

    if (vertical) {
        let margin = width / 40
        
        if (parallel) {
            return (
                <g>
                    {getFrame(value_1, null, x, y, width / 2 - margin, height, lineWeight, { ...settings, show_parallel: false })}
                    {getFrame(null, value_2, x + width / 2 + margin, y, width / 2 - margin, height, lineWeight, { ...settings, show_parallel: false })}
                    {utils.getOperationSign(
                        x + width /2,
                        y + height /2,
                        signSize,
                        'plus'
                    )}
                    
                </g>
            )
        } else {
            let value_3 = value_1 - 10
            let value_4 = value_1 + value_2 - value_3 - 10
            return (
                <g>
                    {getFrame(value_1, value_2, x, y, width / 2 - margin, height, lineWeight, settings)}
                    {getFrame(value_3, value_4, x + width / 2 + margin, y, width / 2 - margin, height, lineWeight, settings)}
                </g>
            )
        }
    } else {
        let margin = height / 40

        if (parallel) {
            return (
                <g>
                    {getFrame(value_1, null, x, y, width - signSize , height / 2 - margin, lineWeight, { ...settings, show_parallel: false })}
                    {getFrame(null, value_2, x + signSize , y + height / 2 + margin, width - signSize, height / 2 - margin, lineWeight, { ...settings, show_parallel: false })}
                    {utils.getOperationSign(
                        x + signSize / 2,
                        y + height / 2 + margin + height / 4,
                        signSize,
                        'plus'
                    )}
                </g>
            )
        } else {
            let value_3 = value_1 - 10
            let value_4 = value_1 + value_2 - value_3 - 10
            return (
                <g>
                    {getFrame(value_1, value_2, x, y, width, height / 2 - margin, lineWeight, settings)}
                    {getFrame(value_3, value_4, x, y + height / 2 + margin, width, height / 2 - margin, lineWeight, settings)}
                </g>
            )
        }
    }


}

function getFrame(value_1, value_2, x, y, width, height, lineWeight, settings) {
    const parallel = settings.show_parallel || false
    const vertical = settings.orientation === 'vertical' ? true : false
    const gridCount = 5
    const commutative = settings.commutative
    const colour = commutative ? 'gold' : 'silver'
    const colour2 = value_2 ? commutative ? 'silver' : 'gold' : commutative ? 'gold' : 'silver'
    const margin = lineWeight
    let frameWidth = 0
    let frameHeight = 0
    let size = 0
    let gridValues = []
    let dotsFirstRow = []
    let dotsSecondRow = []

    if (vertical) {
        if (height / gridCount * 2 > width) {
            frameHeight = width / 2 * gridCount - margin * 2
            size = frameWidth / gridCount
            frameWidth = size * 2
            y = y + (height - frameHeight) / 2
        } else {
            frameHeight = height - margin * 2
            size = frameHeight / gridCount
            frameWidth = size * 2
            x = x + (width - frameWidth) / 2
        }

        for (let i = 0; i < 2; i++) {
            for (let j = 0; j < gridCount; j++) {
                if (parallel) {
                    if (i < 1) {
                        if (value_1 > j) {
                            dotsFirstRow.push(
                                utils.getBarWithBolt(x, (y + size * (gridCount - j - 1)), size, size, colour)
                            )
                        } else {
                            dotsFirstRow.push(
                                utils.getBar(x, (y + size * (gridCount - j - 1)), size, size, '#b8cbdb')
                            )
                        }
                    } else {
                        if (value_2 > j) {
                            dotsSecondRow.push(
                                utils.getBarWithBolt((x + size), (y + size * (gridCount - j - 1)), size, size, colour2)
                            )
                        } else {
                            dotsSecondRow.push(
                                utils.getBar((x + size), (y + size * (gridCount - j - 1)), size, size, '#b8cbdb')
                            )
                        }
                    }
                } else {
                    let count = gridCount * i + j
                    if (value_1 + value_2 > count) {
                        dotsFirstRow.push(
                            utils.getBarWithBolt((i < 1 ? x : x + size), (y + size * (gridCount - j - 1)), size, size, value_1 > count ? colour : colour2)
                        )
                    } else {
                        dotsFirstRow.push(
                            utils.getBar((i < 1 ? x : x + size), (y + size * (gridCount - j - 1)), size, size, '#b8cbdb')
                        )
                    }
                }
            }
        }

    } else {
        if (width / gridCount * 2 > height) {
            frameWidth = height / 2 * gridCount - margin * 2
            size = frameWidth / gridCount
            frameHeight = size * 2
            x = x + (width - frameWidth) / 2

        } else {
            frameWidth = width - margin * 2
            size = frameWidth / gridCount
            frameHeight = size * 2
            y = y + (height - frameHeight) / 2
        }

        for (let i = 0; i < 2; i++) {
            for (let j = 0; j < gridCount; j++) {
                if (parallel) {
                    if (i < 1) {
                        if (value_1 > j) {
                            dotsFirstRow.push(
                                utils.getBarWithBolt((x + size * j), y, size, size, colour)
                            )
                        } else {
                            dotsFirstRow.push(
                                utils.getBar((x + size * j), y, size, size, '#b8cbdb')
                            )
                        }
                    } else {
                        if (value_2 > j) {
                            dotsSecondRow.push(
                                utils.getBarWithBolt((x + size * j), (y + size), size, size, colour2)
                            )
                        } else {
                            dotsSecondRow.push(
                                utils.getBar((x + size * j), (y + size), size, size, '#b8cbdb')
                            )
                        }
                    }
                } else {
                    let count = gridCount * i + j
                    if (value_1 + value_2 > count) {
                        dotsFirstRow.push(
                            utils.getBarWithBolt((x + size * j), (i < 1 ? y : y + size), size, size, value_1 > count ? colour : colour2)
                        )
                    } else {
                        dotsFirstRow.push(
                            utils.getBar((x + size * j), (i < 1 ? y : y + size), size, size, '#b8cbdb')
                        )
                    }
                }
            }
        }
    }
    return (
        <g>

            {dotsFirstRow.map(value => {
                return value
            })}

            {dotsSecondRow.map(value => {
                return value
            })}
        </g>
    )

}

function getLayoutSettings(gameContainerWidth, gameContainerHeight) {

    /* const gameContainerMargin = gameContainerWidth * .04

    if (gameContainerWidth * 0.6 > gameContainerHeight) {
        gameContainerWidth = gameContainerHeight / 0.6 - gameContainerMargin
        gameContainerHeight = gameContainerHeight - gameContainerMargin
    } else {
        gameContainerWidth = gameContainerWidth - gameContainerMargin
        gameContainerHeight = gameContainerWidth * 0.6 - gameContainerMargin
    } */

    const sideMargin = gameContainerWidth * .15
    const marginBottom = gameContainerWidth * .1
    const lineWeight = gameContainerWidth / 150
    const arrowSize = gameContainerWidth / 35
    const fontSize = gameContainerWidth / 15

    const gridCount = 5
    const rectWidth = gameContainerWidth - lineWeight * 2 - sideMargin * 2
    const rectHeight = rectWidth / gridCount * 2

    return {
        gameContainerWidth,
        gameContainerHeight,
        sideMargin,
        rectWidth,
        rectHeight,
        marginBottom,
        lineWeight,
        arrowSize,
        fontSize,
        gridCount
    }
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/tenFrame.utils.js